export function getUrlParameters(url) {
    if (!url) {
        url = new URL(window.location.href);
    }
    const filters = {};
    for (const arg of Object.keys(SP.FilterKeys)) {
        const key = SP.FilterKeys[arg];
        const val = url.searchParams.get(key);
        if (val) {
            if (arg === 'conditionCodes') {
                filters[arg] = val.split(' ');
            }
            else if (arg === 'withSerialNumber') {
                filters[arg] = val === '1';
            }
            else if (arg === 'matchAllKeywords') {
                filters[arg] = val === '1';
            }
            else {
                filters[arg] = val;
            }
        }
    }
    return filters;
}
export function getDefaultUrlParams() {
    return {
        conditionCodes: [],
        query: '',
        orderBy: 'relevance',
        order: 'DESC',
        withSerialNumber: null,
        matchAllKeywords: false,
    };
}
export function updateUrlParameter(key, value) {
    const url = new URL(window.location.href);
    if (value == null || typeof value === 'undefined') {
        url.searchParams.delete(key);
    }
    else {
        if (typeof value === 'boolean') {
            url.searchParams.set(key, value ? '1' : '0');
        }
        else if (value instanceof Array) {
            url.searchParams.set(key, value.join(' '));
        }
        else {
            url.searchParams.set(key, value);
        }
    }
    if (window.location.href !== url.toString()) {
        window.history.pushState({
            searchArgs: getUrlParameters(url),
        }, '', url.toString());
    }
}
export function getConditionColor(code) {
    switch (code) {
        case 'NE':
        case 'NS':
        case 'OH':
        case 'SV':
            return 'light-green-darken-2';
        case 'AR':
            return 'skyChaserOrange';
        default:
            return 'jetBlack';
    }
}
export var SP;
(function (SP) {
    let FilterKeys;
    (function (FilterKeys) {
        FilterKeys["conditionCodes"] = "sp_cc";
        FilterKeys["query"] = "sp_q";
        FilterKeys["orderBy"] = "sp_ob";
        FilterKeys["order"] = "sp_o";
        FilterKeys["withSerialNumber"] = "sp_sn";
        FilterKeys["matchAllKeywords"] = "sp_mk";
    })(FilterKeys = SP.FilterKeys || (SP.FilterKeys = {}));
})(SP || (SP = {}));
